import React, { useEffect } from 'react'
import dynamic from 'next/dynamic'

import { useStaticData } from '@mc/static-data-react'
import { GrowthCategory } from '@mc/api'

import { StickyFooter } from 'components/StickyFooter'

import { SubcatPageHero } from '../Hero'
import { useSubcategoryPageEvents } from '../../utils'
import { CategoryBreadcrumbBar } from '../CategoryBreadcrumbBar'
import { OutcomeCarousel } from '../OutcomeCarousel'
import { useVideoContext, VideoContextProps } from '../VideoContext'
import { WhatYouWillLearn } from '../WhatYouWillLearn'

const BelowTheFold = dynamic(
  () => import('../BelowTheFold').then((m) => m.BelowTheFold),
  { ssr: false },
)

const TrailerVideoModal = dynamic(
  () => import('../TrailerVideoModal').then((m) => m.TrailerVideoModal),
  {
    ssr: false,
  },
)

const PageContent = React.memo(() => {
  const { outcomeRanking, primaryCategory } = useStaticData<{
    outcomeRanking: string[]
    primaryCategory: GrowthCategory
  }>()

  const { trackProductListViewed } = useSubcategoryPageEvents()

  useEffect(() => {
    trackProductListViewed(primaryCategory.id)
  }, [primaryCategory, trackProductListViewed])

  return (
    <div>
      <CategoryBreadcrumbBar />
      <SubcatPageHero />
      <WhatYouWillLearn />
      <OutcomeCarousel
        key={outcomeRanking[0]}
        outcomeSlug={outcomeRanking[0]}
        rowIndex={0}
      />
      <BelowTheFold />
      <StickyFooter />
    </div>
  )
})
PageContent.displayName = 'PageContent'

export const SubcategoryPage = () => {
  const { isModalOpen, courseMetaForVideo, closeVideo } =
    useVideoContext<VideoContextProps>()

  return (
    <>
      <PageContent />
      {isModalOpen && courseMetaForVideo && (
        <TrailerVideoModal
          isModalOpen={isModalOpen}
          courseMeta={courseMetaForVideo}
          closeVideo={closeVideo}
        />
      )}
    </>
  )
}
